import AppLayoutAdmin from "@/layouts/AppLayoutAdmin.vue";
import ClassificationIndex from "@/pages/ia/classification/ClassificationIndex.vue";
import ConversationIndex from "@/pages/ia/conversation/ConversationIndex.vue";

export default {
    path: "/ia",
    component: AppLayoutAdmin,
    meta: { requiredAuth: true },
    children: [
        {
            path: "conversation",
            name: "iaConversation",
            component: ConversationIndex
        },
        {
            path: "classification/:filter",
            name: "iaClassification",
            component: ClassificationIndex
        },
        {
            path: "rapport",
            name: "iaRapport",
            component: ClassificationIndex
        },
    ]
}